import ParticipantDetailsPage from "components/pages/ParticipantDetailsPage"

export default function CaptureParticipantDetailsMain(props) {
    return <ParticipantDetailsPage/>
}